import type React from 'react';
import { SearchFilterBar } from 'src/components/SearchFilterBar';
import AkomiMediaCardGrid from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/AkomiMediaCardGrid';
import TopPaginationNavBar from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/TopPaginationNavBar';

const CONTENT_PADDING = '0 24px';

const PushedContents: React.FC = () => {
  return (
    <div>
      <SearchFilterBar />

      <div style={{ padding: CONTENT_PADDING }}>
        <TopPaginationNavBar />
      </div>
      <div style={{ margin: '0 -16px' }}>
        <AkomiMediaCardGrid />
      </div>
    </div>
  );
};

export default PushedContents;
